import { render, staticRenderFns } from "./Journalismadd.vue?vue&type=template&id=dc848bbe&scoped=true&"
import script from "./Journalismadd.vue?vue&type=script&lang=js&"
export * from "./Journalismadd.vue?vue&type=script&lang=js&"
import style0 from "./Journalismadd.vue?vue&type=style&index=0&id=dc848bbe&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dc848bbe",
  null
  
)

export default component.exports